import React from "react";
import { Route as RouteBase, Switch } from "@/compat/router";
import RequiresAppWrapper from "./RequiresAppWrapper";

// The compat router re-exports react-router v6's Route, whose typed props
// don't match the v5-style `<Route path exact>{children}</Route>` usage here.
// Cast to `any` to preserve the existing runtime behaviour.
const Route: any = RouteBase;

const RouteMapper = ({ routes }: any) => {
    return (
        <Switch>
            {routes.map(({ path, component: Component, exact, children, requiredAppId }, index) =>
                children ? (
                    children.map(({ childPath, component: ChildComponent }, childIndex) => (
                        <Route key={childIndex} path={childPath} exact={!!exact}>
                            <ChildComponent />
                        </Route>
                    ))
                ) : (
                    <Route key={index} path={path} exact={!!exact}>
                        {requiredAppId ? (
                            <RequiresAppWrapper appId={requiredAppId}>
                                <Component />
                            </RequiresAppWrapper>
                        ) : (
                            <Component />
                        )}
                    </Route>
                )
            )}
        </Switch>
    );
};

export default RouteMapper;
